import React, { FC, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { Box, Modal } from "@mui/material";
import Image from "next/image";
import classes from "./ProductZoomInModal.module.scss";
interface ProductZoomInModalProps {
  handleZoomIn: any;
  image?: any;
}
const ProductZoomInModal: FC<ProductZoomInModalProps> = ({
  handleZoomIn,
  image,
}) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const handleModalClose = () => {
    setIsZoomed(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "98%",
    height: "98%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const customLoader = ({ src }: any) => {
    return src;
  };

  return (
    <div>
      <ZoomInIcon
        fontSize="large"
        className={classes["zoomIcon"]}
        onClick={() => {
          handleZoomIn();
          setIsZoomed(true);
        }}
        data-testid="zoom-icon"
      />
      {isZoomed && (
        <Modal
          aria-labelledby="modal-title"
          aria-describedby="modal-desc"
          open={isZoomed}
          onClose={handleModalClose}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
            height: "auto",
          }}
          data-testid="modal"
        >
          <Box sx={style} data-testid="modal-box">
            <Image
              src={`${image?.url}?fm=webp&w=1920&h=1080`}
              alt={image?.title}
              height="100%"
              width="100%"
              loader={customLoader}
              layout="fill" //To make image layout changes "fill" | "fixed" | "intrinsic" | "responsive"
              // objectFit="cover"
            />
            <CloseIcon
              fontSize="large"
              className={classes["closeIcon"]}
              onClick={handleModalClose}
              data-testid="close-icon"
            />
          </Box>
        </Modal>
      )}
    </div>
  );
};

export default ProductZoomInModal;
